import * as React from "react";
import { GitMerge, X } from "lucide-react";

import { Button } from "@/components/ui/button";

export type WorkspaceCombineSelectionBarProps = {
  selectedCount: number;
  canCombine: boolean;
  onCombine: () => void;
  onClear: () => void;
};

export function WorkspaceCombineSelectionBar({
  selectedCount,
  canCombine,
  onCombine,
  onClear,
}: WorkspaceCombineSelectionBarProps): React.ReactElement {
  return (
    <div
      data-workspace-combine-selection-bar=""
      className="pointer-events-auto flex items-center gap-2 rounded-[6px] border border-border bg-card px-3 py-2 shadow-md backdrop-blur supports-[backdrop-filter]:bg-card/95"
    >
      <p className="m-0 font-[family-name:var(--font-primary)] text-sm text-[#6b7280] dark:text-sidebar-muted-foreground">
        {canCombine ? (
          <>
            <span className="text-[color:var(--brand-tropical-surf)]">{selectedCount}</span>
            {" policies selected · first sets the report window"}
          </>
        ) : (
          <>
            Select at least one more same-strategy policy
            {selectedCount > 0 ? (
              <>
                {" · "}
                <span className="text-[color:var(--brand-tropical-surf)]">{selectedCount}</span>
                {" selected"}
              </>
            ) : null}
          </>
        )}
      </p>
      <Button
        type="button"
        variant="gradient"
        size="sm"
        disabled={!canCombine}
        onClick={onCombine}
      >
        <GitMerge className="size-3.5" aria-hidden />
        Combine policies…
      </Button>
      <Button
        type="button"
        variant="ghost"
        size="icon"
        className="size-8 shrink-0 text-[#6b7280] dark:text-white"
        aria-label="Cancel combine"
        onClick={onClear}
      >
        <X className="size-4" aria-hidden />
      </Button>
    </div>
  );
}
